import BaseListagem from "components/BaseListagem";
import ModalGerarAuditoria from "pages/auditoria5s/execucao/modal/ModalGerarAuditoria";
import Setor from "model/administracao/cadastro/Setor";
import Auditoria from "model/auditoria5s/auditoria/Auditoria";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import ExecucaoAuditoriaService from "service/auditoria5s/ExecucaoAuditoriaService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterDataHora } from "utils/convert";
import { dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, IdListMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, multiselectFilterTemplate, NumberMatchModeOptions, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";
import { useFilter } from "contexts/FilterContext";
import Pageable from "model/page/Pageable";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";

const auditoriaService = new AuditoriaService();
const execucaoAuditoriaService = new ExecucaoAuditoriaService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function MinhasAuditorias() {
    const filterContext = useFilter();

    const [setoresDisponiveis, setSetoresDisponiveis] = useState<Setor[]>([]);
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [rows, setRows] = useState<Auditoria[]>([]);
    const [pageable, setPageable] = useState(filterContext.pageables["minhasAuditorias"] ? filterContext.pageables["minhasAuditorias"] : new Pageable(0, 10, "nome,ASC", 0));
    const [totalElements, setTotalElements] = useState<number>(0);
    const [planos, setPlanos] = useState<PlanoAuditoria[]>([]);

    const [podeGerar, setPodeGerar] = useState(false);
    const [visibleModalGerar, setVisibleModalGerar] = useState(false);


    const navigate = useNavigate();

    const defaultFilters: DataTableFilterMeta = {
        numero: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        setor: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        planoAuditoria: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataGeracao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        mes: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        ano: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: ['C', 'A'],
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        }
    }
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const setorFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={setoresDisponiveis} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    useEffect(() => {
        auditoriaService.getSetoresDisponiveis().then(response => setSetoresDisponiveis(response)).catch(() => setSetoresDisponiveis([]));
        auditoriaService.getPlanosDisponiveis().then(response => setPlanos(response)).catch(() => setPlanos([]));
        usuarioLogadoService.getAcoesUsuarioLogado().then(json => {
            json.find((acao) => acao.sigla === 'GERAR_AUDITORIA_APP') ? setPodeGerar(true) : setPodeGerar(false);
        }).catch(err => {
            console.error(err);
        });
    }, []);

    useEffect(() => {
        if (filterContext.filters["minhasAuditorias"]) {
            setFilters(filterContext.filters["minhasAuditorias"])
        }
        setFiltrando(true);
    }, []);

    useEffect(() => {
        setFiltrando(true);
    }, [filters, pageable]);

    useEffect(() => {
        if (filtrando) {
            filterContext.updateFilters("minhasAuditorias", filters);
            filterContext.updatePageable("minhasAuditorias", pageable);


            execucaoAuditoriaService
                .pesquisar(pageable, filters)
                .then(lista => {
                    setFiltrando(false);
                    setRows(lista.content);
                    setTotalElements(lista.totalElements);
                })
                .catch(err => {
                    setFiltrando(false);
                });
        }
    }, [filtrando, pageable]);

    const onPage = (event: DataTableStateEvent) => {

        setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
        setFiltrando(true);

    };

    function navigateToExecutar(auditoria: Auditoria): void {
        let url = `executar/${auditoria.id}`;

        if (auditoria.status == "CRIADA") {
            execucaoAuditoriaService.iniciar(auditoria).then(() => navigate(`${url}`)).catch(() => navigate(`${url}`));
        } else {
            navigate(`${url}`);
        }
    }

    function getHeader() {

        return (
            <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                <div></div>
                <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>{'Minhas Auditorias'}</span>
                <div >
                    <Button type="button" icon="pi pi-filter-slash" label="Limpar" outlined onClick={clearFilter} style={{ marginRight: 8 }} />
                    <Button key={0} label="Gerar Auditoria" icon="pi pi-plus" onClick={() => setVisibleModalGerar(true)} disabled={!podeGerar} />
                </div>
            </div>
        )
    }

    const clearFilter = () => {
        setFilters(defaultFilters || {});
    }

    return (
        <>
            {visibleModalGerar ? <ModalGerarAuditoria
                visible={visibleModalGerar}
                setVisible={(e) => { setVisibleModalGerar(e) }}
                onConfirm={() => { setFiltrando(true); }}
            /> : null}
            <DataTable
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                filters={filters}
                onFilter={(e) => { setFilters(e.filters) }}
                header={getHeader()}
                value={rows} lazy dataKey="id" paginator
                first={pageable.first} rows={10} totalRecords={totalElements} onPage={onPage}
                loading={filtrando} tableStyle={{ minWidth: '75rem' }}
                emptyMessage="Nenhum registro encontrado"
            >
                <Column
                    field="numero" header="Nr."
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column
                    field="setor.nome" header="Setor" filterField="setor"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={setorFilterTemplate}
                />
                <Column
                    field="planoAuditoria.nome" header="Plano de auditoria" filterField="planoAuditoria"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => multiselectFilterTemplate(options, planos)}
                />
                <Column field="dataGeracao" header="Dt. Geração" body={(rowData: Auditoria) => converterDataHora(rowData.dataGeracao)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataGeracao"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                />
                <Column
                    field="mes" header="Mês"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column
                    field="ano" header="Ano"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column field="status" header="Status" filterField="status"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => statusFilterTemplate(options, auditoriaService.getStatusAuditoriaFilter())}
                    body={(rowData) => auditoriaService.getStatusAuditoria(rowData.status)}
                />
                <Column body={(rowData: Auditoria) => <Button label={rowData.status == "CRIADA" ? "Iniciar" : rowData.status == "EM_ANDAMENTO" ? "Continuar" : "Visualizar"} onClick={() => navigateToExecutar(rowData)} />} />
            </DataTable>
        </>

    )
}
